import React, { memo, useState } from "react";
import styled from "styled-components";
import MultisplitItem from "./MultisplitItem";
import { MdAdd } from "react-icons/md";
import { SubmitButton } from "../InputFields/utils";
import NumberInputField from "../InputFields/NumberInputField";

interface MultisplitItemsProps {
  item: any;
  control: any;
  reset: boolean;
  setValue: any;
}

const createNewItem = (id: number) => {
  return {
    id,
    title: `Вътрешно тяло ${id}`,
    data: [
      {
        required: true,
        options: undefined,
        type: "image",
        title: "Снимка",
        name: `inner_item_image_file_${id}`,
      },
      {
        required: true,
        options: undefined,
        type: "text",
        title: "Модел",
        name: `inner_item_model_${id}`,
      },
      {
        required: true,
        options: undefined,
        type: "number",
        title: "Цена (лв.)",
        name: `inner_item_price_${id}`,
      },
      {
        required: true,
        rules: {
          required: { value: true, message: "Полето е задължително" },
        },
        options: undefined,
        type: "number",
        title: "Цена (€)",
        name: `inner_item_price_eur_${id}`,
        linkedTo: `inner_item_price_${id}`,
      },
      {
        type: "select",
        title: "Тип",
        name: `inner_item_type_${id}`,
        required: true,

        options: ["стенен", "таванен", "подов"],
      },
    ],
  };
};

const countField = (n: number) => {
  return {
    required: true,
    options: undefined,
    type: "number",
    title: "Брой вътрешни тела",
    name: `mutisplit_count`,
    value: n,
  };
};

const MultisplitItems: React.FC<MultisplitItemsProps> = ({ item, control, reset, setValue }) => {
  const [options, setOptions] = useState<any[]>(
    item.value && item.value.length !== 0 ? item.value : [] //new Array(createNewItem(0))
  );

  const [countState, setCountState] = useState(
    item.value && item.value.length !== 0 ? countField(item.value.length - 1) : countField(0)
  );

  const renderFields = (option: any) => {
    return (
      <MultisplitItem
        key={option.id}
        id={option.id}
        item={option}
        reset={reset}
        setValue={setValue}
        control={control}
        onDelete={onDelete}
      />
    );
  };

  const onAdd = () => {
    let _options = [...options];
    const newId = _options.length > 0 ? _options[_options.length - 1].id + 1 : 0;
    _options.push(createNewItem(newId));
    setOptions(_options);
    setValue("mutisplit_count", newId);
  };

  const onDelete = (id?: number) => {
    let _options = [...options];
    const index = _options.findIndex((item) => item.id === id);
    if (index > -1) {
      _options.splice(index, 1);
      setOptions(_options);
    }
  };

  return (
    <MultisplitItemsContainer>
      <>{options.map((option: any) => renderFields(option))}</>
      <CountHidden>
        <NumberInputField item={countState} control={control} reset={reset} setValue={setValue} />
      </CountHidden>
      <Buttons>
        <SubmitButton variant="contained" color="primary" startIcon={<MdAdd size="1.5rem" />} onClick={onAdd}>
          Добави
        </SubmitButton>
      </Buttons>
    </MultisplitItemsContainer>
  );
};

const MultisplitItemsContainer = styled.div``;
const Buttons = styled.div`
  display: flex;
  justify-content: center;
`;

const CountHidden = styled.div`
  display: none;
`;
export default memo(MultisplitItems);
